import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root',
})
/**
 * SsoRestrictGuard prevents access to routes for users authenticated via SAML.
 * If a user is authenticated with SAML, they are redirected to the '/sso-invalid' route.
 */
export class SsoRestrictGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate(): Promise<boolean> {
    const user = await Auth.currentAuthenticatedUser();
    const identities = user?.attributes?.identities
      ? JSON.parse(user.attributes.identities)
      : [];
    if (identities.length > 0 && identities[0].providerType === 'SAML') {
      this.router.navigate(['/sso-invalid']);
      return false;
    }
    return true;
  }

  canActivateChild(): boolean | Promise<boolean> {
    return this.canActivate();
  }
}
